import { CampaignForView } from "./types";

export function buildApproverLink(
  campaign: CampaignForView,
  subaccountLink: (relativeLink: string) => string
): {
  fullLink: string;
  path: string;
} {
  const path = subaccountLink(`/approve/${campaign.id}`);
  return {
    fullLink: `${document.location.protocol}//${document.location.host}${path}`,
    path,
  };
}
